import { ResourceTable } from "@/components/data/ResourceTable";
import { PiecesJointes } from "@/components/data/Network";
import { PageHeader } from "@/components/data/StatusBadge";

export default function OperationsPage() {
  return (
    <div>
      <PageHeader title="Opérations commerciales & opérationnelles" subtitle="Visites, prospection, formations, installations… Planifiée → En cours → Réalisée (ou Annulée). Aucun impact financier : l'argent passe par la Trésorerie." />
      <ResourceTable res="operations" detailExtra={(row) => <PiecesJointes res="operations" entityId={row.id} />} />
    </div>
  );
}
